// store/modules/auth.js
import { loginUser, registerUser, logoutUser } from '@/services/api';

const state = {
  token: sessionStorage.getItem('token') || '',
  user: null,
  status: '',
};

const mutations = {
  auth_request(state) {
    state.status = 'loading';
  },
  auth_success(state, { token, user }) {
    state.status = 'success';
    state.token = token;
    state.user = user;
  },
  auth_error(state) {
    state.status = 'error';
  },
  logout(state) {
    state.status = '';
    state.token = '';
    state.user = null;
  },
  set_user(state, user) {
    state.user = user;
  },
};

const actions = {
  async login({ commit }, user) {
    commit('auth_request');
    try {
      const response = await loginUser(user);
      const token = response.data.token;
      const userData = response.data.user;
      sessionStorage.setItem('token', token);
      sessionStorage.setItem('user', JSON.stringify(userData));
      commit('auth_success', { token, user: userData });
    } catch (error) {
      commit('auth_error');
      sessionStorage.removeItem('token');
      throw error;
    }
  },
  async register({ commit }, user) {
    commit('auth_request');
    try {
      await registerUser(user);
    } catch (error) {
      commit('auth_error');
      throw error;
    }
  },
  logout({ commit }) {
    commit('logout');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    logoutUser();
  },
  checkAuthState({ commit }) {
    const token = sessionStorage.getItem('token');
    let user = null;

    try {
      const userData = sessionStorage.getItem('user');
      if (userData) {
        user = JSON.parse(userData);
      }
    } catch (error) {
      console.error("Error parsing user from sessionStorage:", error);
      sessionStorage.removeItem('user');
    }

    if (token && user) {
      commit('auth_success', { token, user });
    } else {
      commit('logout');
    }
  },
};

const getters = {
  isLoggedIn: (state) => !!state.token,
  authStatus: (state) => state.status,
  currentUser: (state) => state.user,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
